import { useEffect, useState } from "react";
import axios from "axios";
import { CONTRACTS_API } from "./contracts";

// GET /contracts/config, fetched once per page load: the agreement types and their
// documents, the template fields, the consent wording, and whether conversion and
// email are set up on this server.
let cached = null;

export function useContractConfig() {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    if (cached) return;
    let live = true;
    axios.get(`${CONTRACTS_API}/config`)
      .then(res => { cached = res.data; if (live) setConfig(res.data); })
      .catch(() => {});
    return () => { live = false; };
  }, []);
  return config;
}
